export default {
  testServer: 'https://saas.mintoucharge.com/manager/',
  formalServer: 'https://saas.mintoucharge.com/manager/'
}



// WEBPACK FOOTER //
// ./src/util/serverConfig.js